import { useInvalidate } from "@refinedev/core";

/** After any write: reload every areas list query (the table and the option lists). */
export const useReloadAreas = () => {
  const invalidate = useInvalidate();
  return () => {
    void invalidate({
      resource: "areas",
      dataProviderName: "areas",
      invalidates: ["list"],
    });
  };
};
